export class UserNotification {
  constructor(type = 'success', payload = {}) {
    this.type = type;
    this.payload = payload;
    Object.defineProperty(this, 'message', {
      enumerable: true,
      configurable: true,
      get: () => { const { message } = this.payload; return message; },
      set: (value) => { this.payload = { ...this.payload, message: value } }
    });
    Object.defineProperty(this, 'value', {
      enumerable: true,
      configurable: true,
      get: () => { const { value } = this.payload; return value; },
      set: (value) => { this.payload = { ...this.payload, value } }
    });
  }
  emit(emitter) {
    if (emitter && typeof emitter.$emit === 'function') {
      return emitter.$emit(this.type, this);
    }
  }
}

export const UserNotifications = {
  BackgroundActivityOn: new UserNotification('backgroundActivity', { value: true }),
  BackgroundActivityOff: new UserNotification('backgroundActivity', { value: false }),
  Success: (message) => new UserNotification('userNotification', { subType: 'success', message }),
  Error: (message) => new UserNotification('userNotification', { subType: 'error', message }),
  UserChanged: (userId) => new UserNotification('userChanged', { value: userId })
};

export async function withUINotification(operation, errorMessage, successMessage) {
  try {
    try {
      UserNotifications.BackgroundActivityOn.emit(this);
      if (operation) {
        await operation();
      }
      if (successMessage) {
        UserNotifications.Success(successMessage).emit(this)
      }
    } finally {
      UserNotifications.BackgroundActivityOff.emit(this)
    }
    return true;
  } catch (err) {
    const { message: exceptionMessage, response: { status = 504, data: { Message: payloadErrorMessage } = {} } = {} } = err
    if (errorMessage || payloadErrorMessage || exceptionMessage) {
      const message = `${errorMessage || ''}${payloadErrorMessage ? '\n' + payloadErrorMessage : ''}${exceptionMessage ? '\n' + exceptionMessage : ''}`
      UserNotifications.Error(message).emit(this)
    }
  }
  return false;
}
